<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    modal-size="large"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="selectedUrl ? `${postUrl}/${inputs.id}` : postUrl"
      >
      <div class="row">
        <div class="col-md-6">
          <label for="trade_association_number">
            Trade Association Number
          </label>
          <app-input
              id="trade_association_number"
              type="text"
              v-model="inputs.trade_association_number"
              :required="true"
          />
        </div>

        <div class="col-md-6">
          <label for="association_name">
            Association Name
          </label>
          <app-input
              id="association_name"
              type="text"
              v-model="inputs.association_name"
              :required="true"
          />
        </div>

        <div class="col-md-6">
          <label for="end_date">
            End Date
          </label>
          <app-input
              id="end_date"
              type="date"
              v-model="inputs.end_date"
              :required="true"
          />
        </div>
        <div class="col-md-6">
          <label for="code">
            Code
          </label>
          <app-input
              id="code"
              type="text"
              v-model="inputs.code"
              :required="true"
          />
        </div>
      </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import * as actions from "../../../../../Config/ApiUrl";
import { axiosPost} from "../../../../../../app/Helpers/AxiosHelper";
import AppLibrary from "../../../../../Helpers/AppLibrary";


export default {
  name: "AssociationAddModal",
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    companyId: Number,
  },
  data() {
    return {
      fileView: false,
      postUrl:actions.COMPANY_TRADE_ASSOCIATION_STORE,
      preloader: false,
      roleLists: [],
      branchList: [],
      inputs: {
        company_id: this.companyId,
      },
      statusLists: [
        { id: "no", value: "No" },
        { id: "yes", value: "Yes" },
      ],
      modalId: "association-add-edit-modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
    }
  },
  methods: {
    submit() {
      this.inputs.end_date = this.getDateFormatForBackend(this.inputs.end_date)

      let formData = new FormData;
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      if (this.modalTitle == "Edit") {
        this.preloader = true;
        axiosPost(actions.COMPANY_TRADE_ASSOCIATION_UPDATE, formData)
          .then((res) => {
            
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#association-add-edit-modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      } else {
      this.save(formData);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.preloader = false;
    },
  },

  mounted() {
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
<style>
.custom-file-label{
  height: 36px !important;
}
</style>
